import { useEffect } from 'react';
import Raven from 'raven-js';
import UIFlex from 'UIComponents/layout/UIFlex';
import UIErrorMessage from 'UIComponents/error/UIErrorMessage';
import UILoadingSpinner from 'UIComponents/loading/UILoadingSpinner';
import { jsx as _jsx } from "react/jsx-runtime";
function LoadingPage(props) {
  const {
    error,
    pastDelay
  } = props;
  let content = null;
  useEffect(() => {
    if (error instanceof Error) {
      Raven.captureException(error);
    }
  }, [error]);
  if (error) {
    content = /*#__PURE__*/_jsx(UIErrorMessage, {
      type: "badRequest"
    });
  } else if (pastDelay) {
    content = /*#__PURE__*/_jsx(UILoadingSpinner, {
      size: "medium"
    });
  }
  if (!content) {
    return null;
  }
  return /*#__PURE__*/_jsx(UIFlex, {
    justify: "center",
    align: "center",
    style: {
      position: 'absolute'
    },
    children: content
  });
}
export default LoadingPage;